import { getAppCfg } from "../../core/app-cfg";
import { CONSTANTS } from "../../core/constants";
import { getDomainCfg } from "../../core/state";

export const LS_VERSION = "LS_2";

export const getUserDataKey = (projectId? : string) : string => {
  const domainCfg = getDomainCfg();
  if (projectId !== undefined) {
    return (
      CONSTANTS.LS_PREFIX +
      domainCfg.viewSettings.codeId +
      projectId
    );
  }

  const appCfg = getAppCfg();
  return (
    CONSTANTS.LS_PREFIX +
    domainCfg.viewSettings.codeId +
    appCfg.projectId
  );
}
